import { forwardRef } from "react";
import Button, { ButtonProps } from "./Button";
import transWidthHeight from "./utils/transWidthHeight";

type PillButtonProps = ButtonProps;
const PillButton = forwardRef<HTMLButtonElement, PillButtonProps>(({
    children,
    border = 1,
    variant = "white",
    shape = "pill",
    fullWidth = false,
    shadow = 0,
    icon, iconPosition = "left",
    width,
    height,
    color,
    backgroundColor,
    style,
    ...props
    
}, ref) => {
    const widthValue = transWidthHeight(width);
    const heightValue = transWidthHeight(height);
    return (
        <Button
            ref={ref}
            border={border}
            variant={variant}
            shape={shape}
            fullWidth={fullWidth}
            shadow={shadow}
            icon={icon}
            iconPosition={iconPosition}
            width={widthValue}
            height={heightValue}
            color={color}
            backgroundColor={backgroundColor}
            style={{
                padding: "10px 22px",
                minWidth: "revert",
                fontSize: "var(--font-size-desktop-md)",
                ...style
            }}
            {...props}
        >
            {children}
        </Button>
    )
});

PillButton.displayName = "PillButton";

export default PillButton;